var ViewportHelper = function() {

  var body = $("body"),
    win = $(window).width(),
    mobileMax = 767,
    tabletMax = 1023,
    desktopMin = 1024,
    desktop = "desktop",
    tablet = "tablet",
    mainNavTablet = "mainNavTablet",
    mobile = "mobile";

  // Regular Helper Classes
  if (win > mobileMax && win < desktopMin) {
    body.addClass(tablet);
    body.removeClass(desktop);
    body.removeClass(mobile);
  }
  if (win < mobileMax + 1) {
    body.addClass(mobile);
    body.removeClass(desktop);
    body.removeClass(tablet);
    body.removeClass(mainNavTablet);
  }
  if (win > tabletMax) {
    body.addClass(desktop);
    body.removeClass(tablet);
    body.removeClass(mobile);
  }

  // Main Nav Tablet Special
  if (win > mobileMax && win < desktopMin + 1) {
    body.addClass(mainNavTablet);
  }

  if (win > desktopMin) {
    body.removeClass(mainNavTablet);
  }
};

export {ViewportHelper};